import React from 'react';

function hint(): React.ReactElement {
  return (
    <path
      fill="inherit"
      d="M8 0a8 8 0 11-8 8 8 8 0 018-8zm0 2a6 6 0 106 6 6 6 0 00-6-6zm0 9.27a.85.85 0 11-.85.85.85.85 0 01.85-.85zM8.06 3c.44 0 .79.26.79.59v6.2a.71.71 0 01-.79.6h-.12a.71.71 0 01-.79-.6V3.62c0-.33.35-.59.79-.59z"
    ></path>
  );
}

export default hint;
